module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1325.760bc934.svg";